import Toastr from '../../../itrust_common/components/Toastr';

const DEFAULT_STATE = {
  loading: false,
  saving: false,
  status: null,
  integrationLog: null,
  error: null,
};

export default function faitStatusReducer(state = DEFAULT_STATE, action) {
  const response = action.payload && (action.payload.data || action.payload.response);

  switch (action.type) {
    case 'FAIT_STATUS_LOAD_PENDING':
      return {
        ...state,
        loading: true,
        saving: true,
        error: null,
      };

    case 'FAIT_STATUS_LOAD_REJECTED':
      if (response?.data?.error || response?.error || action.payload?.message) {
        Toastr.handleShow(
          false,
          response?.data?.error || response?.error || action.payload?.message,
          response?.status_code || 500
        );
      }
      return {
        ...state,
        loading: false,
        saving: false,
        error: response?.data?.error || response?.error || action.payload?.message,
      };

    case 'FAIT_STATUS_LOAD_FULFILLED':
      Toastr.handleShow(
        true,
        response?.meta?.message || 'FAIT order status retrieved successfully.',
        200
      );
      return {
        ...state,
        loading: false,
        saving: false,
        status: response?.status || response?.integration_log?.status,
        integrationLog: response?.integration_log || response,
        error: null,
      };

    default:
      return state;
  }
}
